export const GET_QUESTION_SUCCESS = 'GET_QUESTION_SUCCESS';
export const UPDATE_QUESTION_HTML_SUCCESS = 'UPDATE_QUESTION_HTML_SUCCESS';
export const ANSWER_SUCCESS = 'ANSWER_SUCCESS';
export const QUESTION_SUBMITTED_SUCCESS = 'QUESTION_SUBMITTED_SUCCESS';
export const SET_QUESTION = 'SET_QUESTION';
export const MARK_QUESTION_SUCCESS = 'MARK_QUESTION_SUCCESS';
